import { useState } from 'react'
import { X, Send, Handshake } from 'lucide-react'

export default function AgentModal({ open, onClose, docName, companyName, onSubmit }) {
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [message, setMessage] = useState('')
  const [submitted, setSubmitted] = useState(false)

  if (!open) return null

  const reset = () => {
    setEmail(''); setPhone(''); setMessage(''); setSubmitted(false)
  }

  const handleClose = () => {
    reset()
    onClose?.()
  }

  const submit = (e) => {
    e.preventDefault()
    if (!email) return
    onSubmit?.({ docName, companyName, email, phone, message })
    setSubmitted(true)
    setTimeout(handleClose, 1600)
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-ink/40" onClick={handleClose} aria-hidden />
      <div className="relative bg-surface border border-neutral-200 w-full max-w-md animate-fade-in">
        <div className="flex items-center justify-between px-6 py-4 border-b border-neutral-200">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 bg-brand flex items-center justify-center">
              <Handshake size={16} className="text-white" />
            </div>
            <h2 className="text-sm font-semibold text-ink">Contact Bizos Agent</h2>
          </div>
          <button onClick={handleClose} className="text-neutral-400 hover:text-ink" aria-label="Close">
            <X size={18} />
          </button>
        </div>

        {submitted ? (
          <div className="px-6 py-10 text-center">
            <div className="w-12 h-12 bg-brand-soft mx-auto flex items-center justify-center mb-4">
              <Send size={20} className="text-brand" />
            </div>
            <p className="text-sm font-semibold text-ink">Agent request submitted</p>
            <p className="text-xs text-muted mt-1">A Bizos platform admin will assign a localized compliance agent to your case.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="px-6 py-5 space-y-5">
            <p className="text-xs text-muted">
              Need help securing this document? Our localized corporate compliance sub-agents can handle the filing for you.
            </p>

            <div>
              <label className="label-above">Document Name</label>
              <input type="text" value={docName || ''} readOnly className="input-flat bg-neutral-50 text-neutral-600" />
            </div>
            <div>
              <label className="label-above">Company Name</label>
              <input type="text" value={companyName || ''} readOnly className="input-flat bg-neutral-50 text-neutral-600" />
            </div>
            <div>
              <label className="label-above">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="input-flat" placeholder="you@company.com" required />
            </div>
            <div>
              <label className="label-above">Phone Number</label>
              <input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} className="input-flat font-mono" placeholder="+234 800 000 0000" />
            </div>
            <div>
              <label className="label-above">Message</label>
              <textarea value={message} onChange={(e) => setMessage(e.target.value)} className="input-flat" rows={3} placeholder="Describe what you need help with..." />
            </div>

            <div className="flex gap-3 pt-1">
              <button type="button" onClick={handleClose} className="btn-secondary">Cancel</button>
              <button type="submit" className="btn-primary flex items-center gap-1.5">
                <Send size={14} /> Submit Request
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  )
}
